import React, { Fragment } from 'react';
import { Button, Modal } from 'antd';
import { confirmUpdate } from '../popup/confirm';

const confirm = Modal.confirm;

const BtnFormSubmit = ({ onClick, disabled, typeForm }) => {
  const confirmShow = () => {
    confirm({
      ...confirmUpdate,
      onOk: onClick,
    });
  };
  const formSubmit = () => {
    onClick();
  };

  return (
    <Fragment>
      <Button
        type="primary"
        htmlType="submit"
        size="large"
        className="btn-submit executor-sidebar-btn"
        disabled={disabled}
        onClick={
          typeForm === 'edit'
            ? confirmShow
            : typeForm === 'create'
            ? formSubmit
            : onClick
        }
      >
        {typeForm === 'edit' ? 'Сохранить' : 'Сохранить'}
      </Button>
    </Fragment>
  );
};

export default BtnFormSubmit;
